import { connect } from 'react-redux'

import {
    fetchMedia,
} from '../../actions/Media'

import Media from '../../components/Media/Media'

const mapStateToProps = (state) => ({
    videos: state.media.videos,
    images: state.media.images,
    posts: state.media.posts,
    title: state.media.title,

    isError: state.media.isError,
    isErrorNotFound: state.media.isErrorNotFound,
    isFetching: state.media.isFetching,
    isFetched: state.media.isFetched,
})

const mapDispatchToProps = (dispatch) => ({
    fetchMedia: (slug) => {
        dispatch(fetchMedia(slug))
    },
})

export default connect(mapStateToProps, mapDispatchToProps)(Media)
